import { useQuery } from '@apollo/client/react'
import RoomMembers from '../graphql/queries/RoomMembers'
import useCurrentRoom from '../hooks/useCurrentRoom'
import useCurrentUser from '../hooks/useCurrentUser'
import RoomMemberList from './RoomMemberList'
import { useState } from 'react'
import { Popover, Avatar } from '@mantine/core'

const avatarCount = 3

export default function RoomMemberSummary() {
    const room = useCurrentRoom()
    const user = useCurrentUser()
    const { data } = useQuery(RoomMembers, { skip: !room, variables: { roomId: room?.id } })
    const members = data?.room.members
    const [ opened, setOpened ] = useState(false)

    if (!room || !members || members.length <= 1) {
        return null
    }

    const otherMembers = members?.filter( m => m.id !== user.id )
        .sort( (a, b) => b.lastActivity - a.lastActivity )

    const visibleMembers = otherMembers.slice(0, avatarCount)
    const remainingCount = Math.max(0, otherMembers.length - avatarCount)

    return (
        <Popover
            opened={opened}
            onChange={setOpened}
            position="bottom-end"
            shadow="md"
            width={250}
            withArrow
        >
            <Popover.Target>
                <div style={{ cursor: 'pointer' }} onClick={() => setOpened(!opened)}>
                    <Avatar.Group spacing="sm">
                        {visibleMembers.map((member, index) => (
                            <Avatar
                                key={member.id}
                                src={member.avatar}
                                name={member.username}
                                size={30}
                                radius="sm"
                                color="initials"
                            />
                        ))}
                        {remainingCount > 0 && (
                            <Avatar size={30} radius="sm" color="gray">
                                +{remainingCount}
                            </Avatar>
                        )}
                    </Avatar.Group>
                </div>
            </Popover.Target>
            <Popover.Dropdown p={0}>
                <RoomMemberList />
            </Popover.Dropdown>
        </Popover>
    )
}
